import styled, { css } from 'styled-components';

export const Container = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: 24px;
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xs};
    color: ${theme.v2.colors.neutral.lowDark};
  `}
`;

export const Title = styled.span`
  ${({ theme }) => css`
    font-size: ${theme.v2.font.sizes.sm};
    font-weight: ${theme.v2.font.weights.medium};
  `}
`;

export const Message = styled.span`
  ${({ theme }) => css`
    font-size: ${theme.v2.font.sizes.xs};
    color: ${theme.v2.colors.neutral.lowDark};
  `}
`;

export const Actions = styled.div`
  ${({ theme }) => css`
  display: flex;
  gap: 16px;
  justify-content: space-between;

  @media (max-width: ${theme.v2.breakpoints.sm}) {
    flex-direction: column;
    gap: 16px;

    & > button:first-child {
      order: 3;
    }

    & > button:nth-child(2) {
      order: 2;
    }

    & > button:last-child {
      order: 1;
    }
  }

  `}
`;
